var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{ref:"cascader",staticClass:"select-area-content",attrs:{"options":_vm.options,"filterable":"","props":{value:'label'},"placeholder":"省/市/区"},on:{"change":_vm.handleChange},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }